import React, { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { currentLang, changeLang, t } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 120;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const languages = ['RU', 'EN', 'AR'];

  const navLinks = [
    { id: 'about', label: t.about },
    { id: 'services', label: t.services },
    { id: 'process', label: t.howWeWork },
    { id: 'testimonials', label: t.testimonials },
    { id: 'faq', label: t.faq },
  ];

  return (
    <header className={`dark-header ${isScrolled ? 'scrolled' : ''}`} data-testid="header">
      <div className="header-content">
        <div className="logo-container" onClick={() => scrollToSection('hero')}>
          <div className="logo-wrapper">
            <div className="logo-text">CAPITARA</div>
            <div className="logo-tagline">Global Financial Justice</div>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="dark-nav desktop-nav">
          {navLinks.map(link => (
            <a key={link.id} onClick={() => scrollToSection(link.id)} className="dark-nav-link">{link.label}</a>
          ))}
          <div className="language-selector">
            <Globe size={16} color="var(--brand-primary)" />
            {languages.map(lang => (
              <button key={lang} onClick={() => changeLang(lang.toLowerCase())}
                className={`lang-btn ${currentLang === lang.toLowerCase() ? 'active' : ''}`}>{lang}</button>
            ))}
          </div>
          <button onClick={() => {
            navigate('/form?source=pixel2');
          }} className="btn-primary header-cta" data-testid="header-cta">
            {t.getConsultation}
          </button>
        </nav>

        {/* Mobile: CTA + Lang */}
        <div className="mobile-header-right">
          <div className="mobile-lang-mini">
            {languages.map(lang => (
              <button key={lang} onClick={() => changeLang(lang.toLowerCase())}
                className={`mobile-lang-btn ${currentLang === lang.toLowerCase() ? 'active' : ''}`}>{lang}</button>
            ))}
          </div>
          <button onClick={() => {
            navigate('/form?source=pixel2');
          }} className="btn-primary mobile-header-cta" data-testid="mobile-header-cta">
            {t.getConsultation}
          </button>
        </div>
      </div>

      {/* Mobile Nav Strip */}
      <div className="mobile-nav-strip" data-testid="mobile-nav-strip">
        {navLinks.map(link => (
          <a key={link.id} onClick={() => scrollToSection(link.id)} className="mobile-strip-link">{link.label}</a>
        ))}
      </div>
    </header>
  );
};

export default Header;
